// Dish Tech React
import {getStore} from '@dishtech-react/redux';

// Configs
import {formConfig} from '../../config/form-config';
import {serviceConfig} from '../../config/service-config';

// Reducers
import {folderReducer as folder} from './reducers/folder-reducer';
import {storefrontReducer as storefront} from './reducers/storefront-reducer';
import {genreReducer as genre} from './reducers/genre-reducers';

// Middlewares
import {folderMiddleware} from './middlewares/folder-middleware';
import {storefrontMiddleware} from './middlewares/storefront-middleware';
import {genreMiddleware} from './middlewares/genre-middleware';

const [store, history] = getStore({formConfig, serviceConfig}, {folder, genre, storefront}, [
  folderMiddleware,
  genreMiddleware,
  storefrontMiddleware,
]);

export {history};
export default store;
